import React from "react";

export default function SuperAdminAttendanceRecords() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">
        My Attendance Records
      </h1>
      <p className="text-gray-600">This page is under development.</p>
    </div>
  );
}

